module.exports = __webpack_public_path__ + "static/media/img_001_copy_2-900.7b21db32.webp";